export const useSlotsWithSlotContent = () => {
  const measuredElement = ref<HTMLElement | null>(null);
  const slots = useSlots();
  // We do not have a type for 'slot'
  // https://github.com/vuejs/core/issues/4733#issuecomment-1244011992
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const hasSlotContent = (slot: any, slotProps = {}): boolean => {
    if (!slot) return false;

    return slot(slotProps).some((vnode: VNode): boolean => {
      if (Array.isArray(vnode.children)) {
        return !!vnode.children.length;
      }

      return vnode.type !== Comment;
    });
  };

  const getContent = (slotName: string): boolean => {
    return hasSlotContent(slots[slotName]);
  };

  const measureContent = () => {
    let dimensions = null;
    if (measuredElement.value) {
      dimensions = measuredElement.value.getBoundingClientRect();
    }
    return dimensions;
  };

  return {
    getContent,
    slots,
    hasSlotContent,
    measuredElement,
    measureContent,
  };
};
